import styled from 'styled-components';
import { Flex } from 'reflexbox';

import {
	ISelectOptionElementProps,
	ISelectOptionInnerProps,
} from 'packages/kakapo-ui-kit/components/forms/controls/Select';
import { toRgbString } from 'packages/kakapo-ui-kit/helpers/HexColor';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';

interface IRecipientSelectorOptionProps extends ISelectOptionElementProps {
	label: string;
	data?: any;
	innerProps: ISelectOptionInnerProps;
}

const OptionElement = styled.div<ISelectOptionElementProps>`
	cursor: pointer;
	color: rgba(${(props) => toRgbString(props.theme.colors.antracite)}, 0.6);
	font-size: 16px;
	padding: 0;
	border-top: 1px solid ${(props) => props.theme.colors.lightBlue};

	&:hover {
		background-color: transparent;
		color: rgba(${(props) => toRgbString(props.theme.colors.antracite)}, 1);
	}

	${(props) =>
		props.isFocused &&
		`
		background-color: transparent;
		color: rgba(${toRgbString(props.theme.colors.antracite)}, 1.0);
	`}

	&:active {
		border-top-color: ${(props) => props.theme.colors.lightBlue};
		background-color: ${(props) => props.theme.colors.lightBlue};

		& + .react-select__option {
			border-top: 1px solid ${(props) => props.theme.colors.lightBlue};
		}
	}
`;

const RecipientSelectorOption = ({
	label,
	data,
	isFocused,
	isSelected,
	innerProps,
}: IRecipientSelectorOptionProps) => {
	return (
		<OptionElement
			isFocused={isFocused}
			isSelected={isSelected}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...innerProps}
		>
			<Flex flexDirection="row" alignItems="center">
				<Column my={3} ml={3}>
					{data.data != null ? (
						<PersonAvatar person={data.data} size={PersonAvatarSize.Small} />
					) : (
						<PersonAvatar name="@" size={PersonAvatarSize.Small} />
					)}
				</Column>

				<Column my={3} ml={2} mr={3}>
					{label}
				</Column>
			</Flex>
		</OptionElement>
	);
};

export default RecipientSelectorOption;
